import React from 'react'
import Card from '@mui/material/Card';

const Contact = () => {
  return (
    <Card>
        <h1>Contact Us</h1>
    </Card>
  )
}

export default Contact